import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const CustomObjectsLegacyRedirect = lazy(() =>
  import("@scenes/CustomObjects").then((module) => ({
    default: module.CustomObjectsLegacyRedirect,
  }))
);

export const AccountsNRO: NavigationRoutingObject = {
  Component: CustomObjectsLegacyRedirect,
  componentFeatureFlippers: ["accounts_nro_component"],
  section: "data-settings",
  heading: (t: I18nT<"dashboard-navigation">) => t("accounts-nro-heading", "Accounts"),
  pageNameForTracking: () => "Accounts",
  description: (t: I18nT<"dashboard-navigation">) =>
    t("accounts-nro-description", "Store business records and connect them to your users"),
  icon: "nav-system-accounts",
  tag: "early-access",
  getDeveloperNavigationAllowed: ({ featureOn }) => featureOn("accounts_nro_component"),
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/dashboard/accounts/:appGroupId",
};
